import { demoFile, component, componentWithVariants, variant, story, CLICK, POPUP } from 'system/demo';
import { ModDashboardThreadCard, ModDashboardThreadDetails, ModDashboardThreadsOverview } from 'open-modules/zdf/component/moddashboard/moddashboardthreads';
import { EnableModDashboardThreadDetailsFeature } from 'open-modules/zdf/feature/question/enable-thread-mod-dashboard-view';
import { defaultPersonaList } from 'util/testpersonas';

const modDashboardDemoData = {
    modulePublicQuestion: {
        thread1: { key: 't1', from: 'a', question: 'Q1', time: Date.now() },
        thread2: { key: 't2', from: 'b', question: 'Q2', time: Date.now() - 1000 },
    },
    modTaskQueues: { thread1: {}, thread2: {} },
    threadQueueCounts: {},
    serverCalls: {},
    instanceData: { thread1: { collections: {}, globals: {} } },
};

demoFile('open-modules/zdf/component/moddashboard/moddashboardthreads');

const author = defaultPersonaList[0];
const modulePublic = {
    question: { ...modDashboardDemoData.modulePublicQuestion },
    moderation: {
        queue: { ...modDashboardDemoData.modTaskQueues.thread1 },
        thread_queue_count: { ...modDashboardDemoData.threadQueueCounts },
    },
};

const embeddedInstanceData = {
    question: {
        [modDashboardDemoData.modulePublicQuestion.thread1.key]: modDashboardDemoData.instanceData.thread1,
    },
};

component('ModDashboardThreadCard', ModDashboardThreadCard, {
    args: { thread: modDashboardDemoData.modulePublicQuestion.thread2, author, onPressCard: () => {} },
    state: { modulePublic, serverCall: modDashboardDemoData.serverCalls },
});

component('ModDashboardThreadDetails', ModDashboardThreadDetails, {
    structureKey: 'question',
    instanceKey: modDashboardDemoData.modulePublicQuestion.thread1.key,
    features: [EnableModDashboardThreadDetailsFeature.key],
    state: {
        modulePublic,
        embeddedInstanceData,
        serverCall: modDashboardDemoData.serverCalls,
        roles: ['Moderator'],
    },
}, []);

component('ModDashboardThreadsOverview', ModDashboardThreadsOverview, {
    state: {
        modulePublic,
        serverCall: modDashboardDemoData.serverCalls,
    },
}, []);
